<red-page-layout>
  <red-page-layout-content class="container">
    <section class="card bg-foreground rounded-lg px-10 pt-8 pb-16">
      <h2 class="mat-card-title my-4 mb-8" i18n>Profile</h2>

      <div class="flex gap-12">
        <div class="mt-4 flex-1 flex flex-col">
          <form [formGroup]="form">
            <div class="flex gap-8">
              <mat-form-field class="flex-1">
                <mat-label i18n>Email Address</mat-label>
                <input matInput formControlName="email" />
                <!-- <span matSuffix>@interloggroup.com</span> -->
              </mat-form-field>

              <mat-form-field class="flex-1">
                <mat-label i18n>Username</mat-label>
                <input matInput formControlName="name" />
                <mat-error *ngIf="form.get('name').hasError('required')" i18n
                  >Username is required</mat-error
                >
              </mat-form-field>
            </div>

            <div class="flex gap-8">
              <mat-form-field class="flex-1">
                <mat-label i18n>Entity</mat-label>
                <mat-select formControlName="entity">
                  <mat-option
                    *ngFor="let entity of entities"
                    [value]="entity"
                    >{{ entity }}</mat-option
                  >
                </mat-select>
              </mat-form-field>

              <mat-form-field class="flex-1">
                <mat-label i18n>Company Name</mat-label>
                <input matInput required formControlName="company" />
                <mat-error *ngIf="form.get('company').hasError('required')" i18n
                  >Company is required</mat-error
                >
              </mat-form-field>
            </div>

            <div class="flex gap-8">
              <mat-form-field class="flex-1">
                <mat-label i18n>Role</mat-label>
                <mat-select formControlName="role">
                  <mat-option *ngFor="let role of roles" [value]="role.value">{{
                    role.label
                  }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="flex-1">
                <mat-label i18n>Language</mat-label>
                <mat-select formControlName="language">
                  <mat-option
                    *ngFor="let language of languages"
                    [value]="language.value"
                  >
                    {{ language.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex gap-8">
              <mat-form-field class="flex-1">
                <mat-label i18n>Date/hour Format</mat-label>
                <mat-select formControlName="datetime">
                  <mat-option
                    *ngFor="let dateFormat of dateFormats"
                    [value]="dateFormat.value"
                  >
                    {{ dateFormat.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="flex-1">
                <mat-label i18n>Decimal Format</mat-label>
                <mat-select formControlName="decimal">
                  <mat-option
                    *ngFor="let decimalFormat of decimalFormats"
                    [value]="decimalFormat.value"
                  >
                    {{ decimalFormat.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
          <form [formGroup]="formPassword">
            <h4 class="body-2 uppercase mb-2" i18n>Security</h4>
            <div class="flex gap-8">
              <mat-form-field class="flex-1">
                <mat-label i18n>Change password</mat-label>
                <input [type]="inputType" matInput formControlName="password" />
                <button
                  (click)="toggleVisibility('password')"
                  mat-icon-button
                  matSuffix
                  matTooltip="Toggle Visibility"
                  type="button"
                >
                  <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
                  <mat-icon
                    *ngIf="!visible"
                    svgIcon="mat:visibility_off"
                  ></mat-icon>
                </button>
                <mat-hint i18n>Click the eye to toggle visibility</mat-hint>
                <mat-error
                  *ngIf="formPassword.get('password').hasError('required')"
                  i18n
                  >Password is required</mat-error
                >
              </mat-form-field>

              <mat-form-field class="flex-1">
                <mat-label i18n>Confirm Password</mat-label>
                <input
                  [type]="confirmInputType"
                  matInput
                  formControlName="confirmPassword"
                  [errorStateMatcher]="errorMatcher('password')"
                  #confirmPasswordInput
                />
                <button
                  (click)="toggleVisibility('confirm-password')"
                  mat-icon-button
                  matSuffix
                  matTooltip="Toggle Visibility"
                  type="button"
                >
                  <mat-icon
                    *ngIf="confirmVisible"
                    svgIcon="mat:visibility"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="!confirmVisible"
                    svgIcon="mat:visibility_off"
                  ></mat-icon>
                </button>
                <mat-hint i18n>Click the eye to toggle visibility</mat-hint>
                <mat-error *ngIf="formPassword.hasError('notSame')" i18n
                  >Passwords do not match</mat-error
                >
              </mat-form-field>
            </div>
          </form>
          <div class="flex flex-col mt-5" *ngIf="userDomains">
            <h4 class="body-2 uppercase mb-2" i18n>Admin Domains</h4>
            <div class="flex gap-8">
              {{ userDomains.join(", ") }}
            </div>
          </div>
        </div>

        <div class="flex-1 flex flex-col gap-12">
          <div class="flex gap-8">
            <div class="flex-1">
              <red-virtual-tree
                *ngIf="clients.length > 0"
                [title]="clientsTitle"
                [items]="clients"
              ></red-virtual-tree>
            </div>
            <div class="flex-1">
              <red-virtual-tree
                *ngIf="carriers.length > 0"
                [title]="carriersTitle"
                [items]="carriers"
              ></red-virtual-tree>
            </div>
          </div>

          <!-- <div class="flex flex-col">
            <h6 class="uppercase mb-4">Homepage Modules</h6>
            <div class="flex gap-8">
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                >Quicksearch</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                >Charts</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="false"
                fxFlex="33"
                class="profile-slide-toggle"
                >Another Module</mat-slide-toggle
              >
            </div>
            <div class="flex gap-8">
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                >Notifications</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="false"
                fxFlex="33"
                class="profile-slide-toggle"
                >Some Module</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                >Quick Upload</mat-slide-toggle
              >
            </div> 
          </div>

          <div class="flex flex-col">
            <h6 class="uppercase mb-4">Quicksearch Type</h6>
            <div class="flex gap-8">
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                ><ng-container i18n>Invoice</ng-container> Number</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                i18n>All Payments completed in the last 30 days</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="false"
                fxFlex="33"
                class="profile-slide-toggle"
                i18n>Last Statement</mat-slide-toggle
              >
            </div>
            <div class="flex gap-8">
              <mat-slide-toggle
                color="primary"
                [checked]="true"
                fxFlex="33"
                class="profile-slide-toggle"
                i18n>Batch Number</mat-slide-toggle
              >
              <mat-slide-toggle
                color="primary"
                [checked]="false"
                fxFlex="33"
                class="profile-slide-toggle"
                i18n>Payment Reference</mat-slide-toggle
              >
            </div>
          </div>-->
        </div>
      </div>
    </section>
  </red-page-layout-content>
</red-page-layout>
